import React, { useCallback, useEffect, useRef } from 'react'
import cx from 'classnames'
import SearchBoxContainer from 'redux/containers/components/layout/search/SearchBoxContainer'
import Icon from 'components/shared/Icon'

export const PageIcon = ({ searchTypeName, searchTypes, className }) => {
  const [{ icon, image } = {}] = searchTypes
    .filter(({ typeName }) => typeName === searchTypeName)

  return icon ? <Icon className={className} name={icon} /> : <img src={image} className={className} />
}

const Search = ({
  aol,
  aolConfigLoaded,
  searchType,
  setCurrentSearchType,
  submitSearchUpdate,
  query,
  flavour,
  params,
  className,
  children
}) => {
  const inputRef = useRef()

  const handleFormOnSubmit = useCallback((e) => {
    e && e.preventDefault()
    submitSearchUpdate({ params, query })
    inputRef.current.blur()
  }, [params, query, inputRef])

  useEffect(() => {
    if (aolConfigLoaded && aol) {
      setCurrentSearchType(searchType)
    }
  }, [aol, searchType, aolConfigLoaded])

  return (
    <nav role='navigation' className={cx(`${flavour}-search`, className)}>
      <form role='search' autoComplete='off' onSubmit={handleFormOnSubmit} className='mhauto-t'>
        <SearchBoxContainer {...{ inputRef }} />
      </form>
      {children}
    </nav>
  )
}

export default Search
